import { Role } from '../../models/Role';

export const calcIsStaff = (role) => role === Role.Worker || role === Role.Manager || role === Role.Admin;
